export const NAVBAR_HEIGHT = 63;
